export interface MeasureOption {
  label: string;
  title: string;
  value: number;
  name: string;
}

const packageMeasureNames = ["package", "piece"];

/**
 * Opcje pierwszej („bazowej") miary w formularzu składnika.
 *
 * Przy dodawaniu baza to opakowanie albo sztuka — z jej gramatury bierze się
 * `packageSize`. Katalog tego nie trzyma: kilkadziesiąt tysięcy produktów
 * z importu ma tam łyżeczkę, porcję czy szklankę. Gdy bieżąca wartość nie ma
 * swojej opcji, antd renderuje surowe id („7" zamiast „Porcja"), a wybór
 * z listy po cichu podmienia miarę przy zapisie — dlatego dokładamy ją z przodu.
 */
export const getBaseMeasureOptions = (
  measureOptions: readonly MeasureOption[],
  currentValue: number | undefined,
): MeasureOption[] => {
  const packageMeasures = measureOptions.filter((measure) => packageMeasureNames.includes(measure.name));

  if (currentValue === undefined || packageMeasures.some((measure) => measure.value === currentValue)) {
    return packageMeasures;
  }

  const currentMeasure = measureOptions.find((measure) => measure.value === currentValue);

  return currentMeasure ? [currentMeasure, ...packageMeasures] : packageMeasures;
};
